import { fetchBlog, fetchBlogs, fetchFAQS, fetchLevelOnePages, fetchSections, fetchTagsFilter, fetchPrivacy as fetchPrivacyApi, fetchTerms as fetchTermsApi, fetchPrivacyCcpa as fetchPrivacyCcpaApi, fetchServiceAddendums as fetchServiceAddendumsApi } from '../util/api';

export const SEARCH_BLOGS_REQUEST = 'app/strapi/SEARCH_BLOGS_REQUEST';
export const SEARCH_BLOGS_SUCCESS = 'app/strapi/SEARCH_BLOGS_SUCCESS';
export const SEARCH_BLOGS_ERROR = 'app/strapi/SEARCH_BLOGS_ERROR';

export const SEARCH_FAQS_REQUEST = 'app/strapi/SEARCH_FAQS_REQUEST';
export const SEARCH_FAQS_SUCCESS = 'app/strapi/SEARCH_FAQS_SUCCESS';
export const SEARCH_FAQS_ERROR = 'app/strapi/SEARCH_FAQS_ERROR';
export const SEARCH_SINGLE_FAQ_SUCCESS = 'app/strapi/SEARCH_SINGLE_FAQ_SUCCESS';

export const SEARCH_SINGLE_BLOGS_SUCCESS = 'app/strapi/SEARCH_SINGLE_BLOGS_SUCCESS';

export const SEARCH_WHY_IPARLEYS_REQUEST = 'app/strapi/SEARCH_WHY_IPARLEYS_REQUEST';
export const SEARCH_WHY_IPARLEYS_SUCCESS = 'app/strapi/SEARCH_WHY_IPARLEYS_SUCCESS';
export const SEARCH_WHY_IPARLEYS_ERROR = 'app/strapi/SEARCH_WHY_IPARLEYS_ERROR';

export const SEARCH_LEVEL_ONE_PAGES_REQUEST = 'app/strapi/SEARCH_LEVEL_ONE_PAGES_REQUEST';
export const SEARCH_LEVEL_ONE_PAGES_SUCCESS = 'app/strapi/SEARCH_LEVEL_ONE_PAGES_SUCCESS';
export const SEARCH_LEVEL_ONE_PAGES_ERROR = 'app/strapi/SEARCH_LEVEL_ONE_PAGES_ERROR';
export const SEARCH_PRIVACY_REQUEST = 'app/strapi/SEARCH_PRIVACY_REQUEST';
export const SEARCH_PRIVACY_SUCCESS = 'app/strapi/SEARCH_PRIVACY_SUCCESS';
export const SEARCH_PRIVACY_ERROR = 'app/strapi/SEARCH_PRIVACY_ERROR';

export const SEARCH_PRIVACY_CCPA_REQUEST = 'app/strapi/SEARCH_PRIVACY_CCPA_REQUEST';
export const SEARCH_PRIVACY_CCPA_SUCCESS = 'app/strapi/SEARCH_PRIVACY_CCPA_SUCCESS';
export const SEARCH_PRIVACY_CCPA_ERROR = 'app/strapi/SEARCH_PRIVACY_CCPA_ERROR';

export const SEARCH_SERVICE_ADDENDUMS_REQUEST = 'app/strapi/SEARCH_SERVICE_ADDENDUMS_REQUEST';
export const SEARCH_SERVICE_ADDENDUMS_SUCCESS = 'app/strapi/SEARCH_SERVICE_ADDENDUMS_SUCCESS';
export const SEARCH_SERVICE_ADDENDUMS_ERROR = 'app/strapi/SEARCH_SERVICE_ADDENDUMS_ERROR';

export const SEARCH_TERMS_REQUEST = 'app/strapi/SEARCH_TERMS_REQUEST';
export const SEARCH_TERMS_SUCCESS = 'app/strapi/SEARCH_TERMS_SUCCESS';
export const SEARCH_TERMS_ERROR = 'app/strapi/SEARCH_TERMS_ERROR';

// ================ Reducer ================ //

const initialState = {
  searchInProgress: false,
  searchBlogsError: null,
  blogsData: [],
  singleBlogData: null,
  searchFaqsError: null,
  faqsData: [],
  singleFaqData: null,
  blogTags: [],
  sectionsData: [],
  searchSectionsError: null,
  levelOnePagesData: [],
  searchLevelOnePagesError: null,
  privacyData: null,
  searchPrivacyError: null,
  privacyCcpaData: null,
  searchPrivacyCcpaError: null,
  termsData: null,
  searchTermsError: null,
  serviceAddendumsData: null,
  searchServiceAddendumsError: null,
};

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case SEARCH_BLOGS_REQUEST:
      return {
        ...state,
        searchInProgress: true,
        searchBlogsError: null,
      };
    case SEARCH_BLOGS_SUCCESS:
      return {
        ...state,
        searchInProgress: false,
        blogsData: payload?.data?.blogs || [],
        blogTags: payload?.data?.filters || [],
        searchBlogsError: null,
      };
    case SEARCH_SINGLE_BLOGS_SUCCESS:
      return {
        ...state,
        searchInProgress: false,
        singleBlogData: payload?.data || null,
        searchBlogsError: null,
      };
    case SEARCH_BLOGS_ERROR:
      return { 
        ...state, 
        searchInProgress: false, 
        searchBlogsError: true 
      };
    case SEARCH_FAQS_REQUEST:
      return {
        ...state,
        searchInProgress: true,
        searchFaqsError: null,
      };
    case SEARCH_FAQS_SUCCESS:
      return {
        ...state,
        searchInProgress: false,
        faqsData: payload?.data?.faqs || [],
        searchFaqsError: null,
      };
    case SEARCH_SINGLE_FAQ_SUCCESS:
      return {
        ...state,
        searchInProgress: false,
        singleFaqData: payload?.data || null,
        searchFaqsError: null,
      };
    case SEARCH_FAQS_ERROR:
      return { 
        ...state, 
        searchInProgress: false, 
        searchFaqsError: true 
      };

    case SEARCH_WHY_IPARLEYS_REQUEST:
      return {
        ...state,
        searchInProgress: true,
        searchSectionsError: null,
      };
    case SEARCH_WHY_IPARLEYS_SUCCESS:
      return {
        ...state,
        searchInProgress: false,
        sectionsData: payload?.data || [],
        searchSectionsError: null,
      };
    case SEARCH_WHY_IPARLEYS_ERROR:
      return { 
        ...state, 
        searchInProgress: false, 
        searchSectionsError: true 
      };

    case SEARCH_LEVEL_ONE_PAGES_REQUEST:
      return {
        ...state,
        searchInProgress: true,
        searchLevelOnePagesError: null,
      };
    case SEARCH_LEVEL_ONE_PAGES_SUCCESS:
      return {
        ...state,
        searchInProgress: false,
        levelOnePagesData: payload?.data || [],
        searchLevelOnePagesError: null,
      };
    case SEARCH_LEVEL_ONE_PAGES_ERROR:
      return { 
        ...state, 
        searchInProgress: false, 
        searchLevelOnePagesError: true 
      };
    case SEARCH_PRIVACY_REQUEST:
      return {
        ...state,
        searchInProgress: true,
        searchPrivacyError: null,
      };
    case SEARCH_PRIVACY_SUCCESS:
      return {
        ...state,
        searchInProgress: false,
        privacyData: payload?.data || null,
        searchPrivacyError: null,
      };
    case SEARCH_PRIVACY_CCPA_REQUEST:
      return {
        ...state,
        searchInProgress: true,
        searchPrivacyCcpaError: null,
      };
    case SEARCH_PRIVACY_CCPA_SUCCESS:
      return {
        ...state,
        searchInProgress: false,
        privacyCcpaData: payload?.data || null,
        searchPrivacyCcpaError: null,
      };
    case SEARCH_PRIVACY_CCPA_ERROR:
      return { ...state, searchInProgress: false, searchPrivacyCcpaError: true };
    case SEARCH_PRIVACY_ERROR:
      return { ...state, searchInProgress: false, searchPrivacyError: true };
    case SEARCH_TERMS_REQUEST:
      return {
        ...state,
        searchInProgress: true,
        searchTermsError: null,
      };
    case SEARCH_TERMS_SUCCESS:
      return {
        ...state,
        searchInProgress: false,
        termsData: payload?.data || null,
        searchTermsError: null,
      };
    case SEARCH_SERVICE_ADDENDUMS_REQUEST:
      return {
        ...state,
        searchInProgress: true,
        searchServiceAddendumsError: null,
      };
    case SEARCH_SERVICE_ADDENDUMS_SUCCESS:
      return {
        ...state,
        searchInProgress: false,
        serviceAddendumsData: payload?.data || null,
        searchServiceAddendumsError: null,
      };
    case SEARCH_SERVICE_ADDENDUMS_ERROR:
      return { ...state, searchInProgress: false, searchServiceAddendumsError: true };
    case SEARCH_TERMS_ERROR:
      return { ...state, searchInProgress: false, searchTermsError: true };
    
    default:
      return state;
  }
}

// ================ Selectors ================ //

export const getBlogsInProgress = state => state.strapi?.searchInProgress || false;
export const getBlogsSelector = state => state.strapi?.blogsData || [];
export const getBlogsTagsSelector = state => state.strapi?.blogTags || [];
export const getBlogsError = state => state.strapi?.searchBlogsError || null;

export const getBlogSelector = state => state.strapi?.singleBlogData || null;
export const getSeoCategory = state => state.strapi?.seoCategory || null;
export const getSeoListings = state => state.strapi?.currentPageResultIds || [];

export const getFaqsInProgress = state => state.strapi?.searchInProgress || false;
export const getFaqsSelector = state => state.strapi?.faqsData || [];
export const getFaqSelector = state => state.strapi?.singleFaqData || null;
export const getFaqsError = state => state.strapi?.searchFaqsError || null;

export const getSectionsInProgress = state => state.strapi?.searchInProgress || false;
export const getSectionsSelector = state => state.strapi?.SectionsData || [];
export const getSectionsError = state => state.strapi?.searchSectionsError || null;

export const getLevelOnePagesInProgress = state => state.strapi?.searchInProgress || false;
export const getLevelOnePagesSelector = state => state.strapi?.levelOnePagesData || [];
export const getLevelOnePagesError = state => state.strapi?.searchLevelOnePagesError || null;

export const getPrivacySelector = state => state.strapi?.privacyData || null;
export const getPrivacyInProgress = state => state.strapi?.searchInProgress || false;
export const getPrivacyError = state => state.strapi?.searchPrivacyError || null;

export const getTermsSelector = state => state.strapi?.termsData || null;
export const getTermsInProgress = state => state.strapi?.searchInProgress || false;
export const getTermsError = state => state.strapi?.searchTermsError || null;

export const getPrivacyCcpaSelector = state => state.strapi?.privacyCcpaData || null;
export const getPrivacyCcpaInProgress = state => state.strapi?.searchInProgress || false;
export const getPrivacyCcpaError = state => state.strapi?.searchPrivacyCcpaError || null;

export const getServiceAddendumsSelector = state => state.strapi?.serviceAddendumsData || null;
export const getServiceAddendumsInProgress = state => state.strapi?.searchInProgress || false;
export const getServiceAddendumsError = state => state.strapi?.searchServiceAddendumsError || null;

// ================ Action creators ================ //

export const searchBlogsRequest = () => ({
  type: SEARCH_BLOGS_REQUEST,
});

export const searchBlogsSuccess = (blogs, filters) => ({
  type: SEARCH_BLOGS_SUCCESS,
  payload: { data: {
    blogs,
    filters
  } },
});

export const searchSingleBlogsSuccess = response => ({
  type: SEARCH_SINGLE_BLOGS_SUCCESS,
  payload: { data: response },
});

export const searchBlogsError = () => ({
  type: SEARCH_BLOGS_ERROR,
});

export const searchFaqsRequest = () => ({
  type: SEARCH_FAQS_REQUEST,
});

export const searchFaqsSuccess = response => ({
  type: SEARCH_FAQS_SUCCESS,
  payload: { data: response },
});

export const searchSingleFaqSuccess = response => ({
  type: SEARCH_SINGLE_FAQ_SUCCESS,
  payload: { data: response },
});

export const searchFaqsError = () => ({
  type: SEARCH_FAQS_ERROR,
});

export const searchSectionsRequest = () => ({
  type: SEARCH_WHY_IPARLEYS_REQUEST,
});
export const searchSectionsSuccess = response => ({
  type: SEARCH_WHY_IPARLEYS_SUCCESS,
  payload: { data: response },
});
export const searchSectionsError = () => ({
  type: SEARCH_WHY_IPARLEYS_ERROR,
});

export const searchLevelOnePagesRequest = () => ({
  type: SEARCH_LEVEL_ONE_PAGES_REQUEST,
});
export const searchLevelOnePagesSuccess = response => ({
  type: SEARCH_LEVEL_ONE_PAGES_SUCCESS,
  payload: { data: response },
});
export const searchLevelOnePagesError = () => ({
  type: SEARCH_LEVEL_ONE_PAGES_ERROR,
});

export const searchPrivacyRequest = () => ({ type: SEARCH_PRIVACY_REQUEST });
export const searchPrivacySuccess = response => ({
  type: SEARCH_PRIVACY_SUCCESS,
  payload: { data: response },
});
export const searchPrivacyError = () => ({ type: SEARCH_PRIVACY_ERROR });

export const searchPrivacyCcpaRequest = () => ({ type: SEARCH_PRIVACY_CCPA_REQUEST });
export const searchPrivacyCcpaSuccess = response => ({
  type: SEARCH_PRIVACY_CCPA_SUCCESS,
  payload: { data: response },
});
export const searchPrivacyCcpaError = () => ({ type: SEARCH_PRIVACY_CCPA_ERROR });

export const searchTermsRequest = () => ({ type: SEARCH_TERMS_REQUEST });
export const searchTermsSuccess = response => ({
  type: SEARCH_TERMS_SUCCESS,
  payload: { data: response },
});
export const searchTermsError = () => ({ type: SEARCH_TERMS_ERROR });

export const searchServiceAddendumsRequest = () => ({ type: SEARCH_SERVICE_ADDENDUMS_REQUEST });
export const searchServiceAddendumsSuccess = response => ({
  type: SEARCH_SERVICE_ADDENDUMS_SUCCESS,
  payload: { data: response },
});
export const searchServiceAddendumsError = () => ({ type: SEARCH_SERVICE_ADDENDUMS_ERROR });

// ================ Thunks ================ //

export const fetchSingleBlog = params => async (dispatch, getState, sdk) => {
  dispatch(searchBlogsRequest());
  try {
    const response = await fetchBlog({ ...params });
    dispatch(searchSingleBlogsSuccess(response?.blog));
    return response;
  } catch (error) {
    dispatch(searchBlogsError());
    // Error dispatched via searchBlogsError
    // throw error;
  }
};

export const fetchAllBlogs = params => async (dispatch, getState, sdk) => {
  dispatch(searchBlogsRequest());

  try {
    // Fetch blogs
    const blogsResponse = await fetchBlogs({ ...params });
    
    dispatch(
      searchBlogsSuccess(
        blogsResponse?.blogs || [],
        blogsResponse?.filters || []
      )
    );
    return blogsResponse?.blogs || [];
  } catch (error) {
    dispatch(searchBlogsError());
    // Error dispatched via searchBlogsError
    // throw error;
  }
};

export const fetchSingleFaq = params => async (dispatch, getState, sdk) => {
  dispatch(searchFaqsRequest());
  try {
    const response = await fetchFAQS({ ...params }); // Fixed: was fetchFaq, should be fetchFAQS
    dispatch(searchSingleFaqSuccess(response?.faq));
    return response;
  } catch (error) {
    dispatch(searchFaqsError());
    // Error dispatched via searchFaqsError
    // throw error;
  }
};

export const fetchAllFaqs = params => async (dispatch, getState, sdk) => {
  dispatch(searchFaqsRequest());

  try {
    // Fetch all FAQs
    const faqsResponse = await fetchFAQS({ ...params });

    dispatch(
      searchFaqsSuccess({
        faqs: faqsResponse?.faqs || [],
      })
    );
    return faqsResponse?.faqs || [];
  } catch (error) {
    dispatch(searchFaqsError());
    // Error dispatched via searchFaqsError
    // throw error;
  }
};

export const fetchSectionsData = params => async (dispatch, getState, sdk) => {
  dispatch(searchSectionsRequest());

  try {
    // Fetch all FAQs
    const sectionsResponse = await fetchSections({ ...params });

    dispatch(
      searchSectionsSuccess({
        sections: sectionsResponse?.data || [],
      })
    );
    return sectionsResponse?.data || [];
  } catch (error) {
    dispatch(searchSectionsError());
    // Error dispatched via searchSectionsError
    // throw error;
  }
};

export const fetchLevelOnePagesData = params => async (dispatch, getState, sdk) => {
  dispatch(searchLevelOnePagesRequest());

  try {
    // Fetch all FAQs
    const levelOnePagesResponse = await fetchLevelOnePages({ ...params });

    dispatch(
      searchLevelOnePagesSuccess({
        sections: levelOnePagesResponse?.data || [],
      })
    );
    return levelOnePagesResponse?.data || [];
  } catch (error) {
    dispatch(searchLevelOnePagesError());
    // Error dispatched via searchLevelOnePagesError
    // throw error;
  }
};

export const fetchPrivacy = params => async (dispatch, getState, sdk) => {
  dispatch(searchPrivacyRequest());
  try {
    const response = await fetchPrivacyApi({ ...params });
    // response.privacy expected
    dispatch(searchPrivacySuccess(response?.privacy || null));
    return response?.privacy || null;
  } catch (error) {
    dispatch(searchPrivacyError());
    // Error dispatched via searchPrivacyError
  }
};

export const fetchPrivacyCcpa = params => async (dispatch, getState, sdk) => {
  dispatch(searchPrivacyCcpaRequest());
  try {
    const response = await fetchPrivacyCcpaApi({ ...params });
    // response.privacyCcpa expected
    dispatch(searchPrivacyCcpaSuccess(response?.privacyCcpa || null));
    return response?.privacyCcpa || null;
  } catch (error) {
    dispatch(searchPrivacyCcpaError());
    // Error dispatched via searchPrivacyCcpaError
  }
};

export const fetchTerms = params => async (dispatch, getState, sdk) => {
  dispatch(searchTermsRequest());
  try {
    const response = await fetchTermsApi({ ...params });
    // response.terms expected
    dispatch(searchTermsSuccess(response?.terms || null));
    return response?.terms || null;
  } catch (error) {
    dispatch(searchTermsError());
    // Error dispatched via searchTermsError
  }
};

export const fetchServiceAddendums = params => async (dispatch, getState, sdk) => {
  dispatch(searchServiceAddendumsRequest());
  try {
    const response = await fetchServiceAddendumsApi({ ...params });
    // response.serviceAddendums expected
    dispatch(searchServiceAddendumsSuccess(response?.serviceAddendums || null));
    return response?.serviceAddendums || null;
  } catch (error) {
    dispatch(searchServiceAddendumsError());
    // Error dispatched via searchServiceAddendumsError
  }
};